import { FC } from 'react'
import CopyIcon from '../CopyIcon/CopyIcon'
import { Container, CopyButtonContainer, DepositAddress, DepositAddressContainer, DepositAddressLabel } from './CopyableAddress.styles'

export interface CopyableAddressProps {
    label?: string;
    address: string;
    onCopy?: () => void;
}

const CopyableAddress: FC<CopyableAddressProps> = ({
    label,
    address,
    onCopy = () => {}
}) => {
    const handleCopy = async () => {
        try {
            await navigator.clipboard.writeText(address)
            onCopy()
        } catch {
            // Ignore clipboard failures so callers can decide whether to surface errors.
        }
    }

    return (
        <Container>
            <DepositAddressLabel>{label}</DepositAddressLabel>
            <DepositAddressContainer>
                <DepositAddress>{address}</DepositAddress>
                <CopyButtonContainer type="button" aria-label="Copy address" onClick={handleCopy}>
                    <CopyIcon />
                </CopyButtonContainer>
            </DepositAddressContainer>
        </Container>
    )
}

export default CopyableAddress
